import { Organization } from '@relyant/ui/src/networking/useOrganization';

export const featureConfig = {
  '': {
    route: '/',
    navBarItem: null,
  },
  home: {
    route: '/',
    navBarItem: null,
  },
  admin: {
    route: '/admin',
    navBarItem: null,
  },
  assistant: {
    route: '/assistant',
    navBarItem: {
      key: '1',
      icon: 'assistant',
      link: 'assistant',
      text: 'Assistant',
    },
  },
  'assistant-flows': {
    route: 'assistant/flows',
    navBarItem: null,
  },
  'assistant-logs': {
    route: 'assistant/logs',
    navBarItem: null,
  },
  integrations: {
    route: '/integrations',
    navBarItem: {
      key: '2',
      icon: 'integrations',
      link: 'integrations',
      text: 'Integrations',
    },
  },
  invoices: {
    route: '/invoices',
    navBarItem: {
      key: '3',
      icon: 'invoices',
      link: 'invoices',
      text: 'Invoices',
    },
  },
  orders: {
    route: '/orders',
    navBarItem: {
      key: '4',
      icon: 'orders',
      link: 'orders',
      text: 'Orders',
    },
  },
  profile: {
    route: '/profile',
    navBarItem: null,
  },
  reports: {
    route: '/reports',
    navBarItem: {
      key: '5',
      icon: 'reports',
      link: 'reports',
      text: 'Reports',
    },
  },
  'report-review': {
    route: '/report-review',
    navBarItem: {
      key: '6',
      icon: 'report-review',
      link: 'report-review',
      text: 'Review',
    },
  },
  research: {
    route: '/research',
    navBarItem: {
      key: '7',
      icon: 'research',
      link: 'research',
      text: 'Research',
    },
  },
};

const defaultFeatureArray = {
  prod: ['home', 'profile', 'reports', 'integrations', 'admin'],
  dev: [
    'home',
    'profile',
    'reports',
    'assistant',
    'assistant-flows',
    'assistant-logs',
    'orders',
    'integrations',
    'admin',
  ],
  local: [
    'home',
    'profile',
    'reports',
    'assistant',
    'assistant-flows',
    'assistant-logs',
    'orders',
    'invoices',
    'research',
    'integrations',
    'admin',
  ],
};

export const getNavBarItems = (organization?: Organization) => {
  let featureArray = defaultFeatureArray[process.env.REACT_APP_ENV];
  if (organization?.org_config?.ui_features) {
    featureArray = Object.keys(organization.org_config.ui_features).filter(
      (feature) => organization.org_config.ui_features[feature]
    );
    // featureArray = featureArray.filter((feature) => organization?.org_config?.ui_features[feature]);
  }

  const navBarItems = [];
  for (let featureName of featureArray) {
    if (featureConfig[featureName].navBarItem) {
      navBarItems.push(featureConfig[featureName].navBarItem);
    }
  }
  return navBarItems;
};

export const getRoutes = (organization?: Organization): string[] => {
  let featureArray = defaultFeatureArray[process.env.REACT_APP_ENV];
  if (organization?.org_config?.ui_features) {
    // featureArray = featureArray.filter((feature) => organization?.org_config?.ui_features[feature]);
    featureArray = Object.keys(organization.org_config.ui_features).filter(
      (feature) => organization.org_config.ui_features[feature]
    );
  }
  const routes = [];
  for (let featureName of featureArray) {
    if (featureConfig[featureName].route) {
      routes.push(featureConfig[featureName].route);
    }
  }
  return routes;
};
